
import RadioComments from "./components/RadioComments";

const OnlineRadio = () => {

    return (  
        <div className="online-radio">
         <h2>Online Radio</h2>
      
         {/* http://stream-52.zeno.fm/pmqx0yebu0hvv?zs=Kk_rxRciS9-5QMvb1gy2rQ */}
         <div className="displayRadio">
         <iframe src="https://stream-52.zeno.fm/pmqx0yebu0hvv?zs=Kk_rxRciS9-5QMvb1gy2rQ" 
         width="100%" height="200px" allow="autoplay" title="Online Radio">
            Error encountered
            </iframe>
          <p><a href="https://stream-52.zeno.fm/pmqx0yebu0hvv?zs=Kk_rxRciS9-5QMvb1gy2rQ" target="_top">
            Click here
            </a>  to connect incase of error</p>
         </div>

         <div className="radioChat-container">
          <RadioComments/>
         </div>

        </div>
    );
}
 
export default OnlineRadio;